import { Language } from '@gf-easy-8/grmnext-foundation';
import LOCAL_STORAGE_KEYS from 'config/localStorageKeys';
import nl from './nl-NL.json';
import da from './da-DK.json';
import de from './de-DE.json';
import en from './en-GB.json';
import us from './en-US.json';
import es from './es-ES.json';
import fi from './fi-FI.json';
import fr from './fr-FR.json';
import it from './it-IT.json';
import pl from './pl-PL.json';
import pt from './pt-PT.json';

export const getLanguageFromLocalStorage = (): string | null => {
  return localStorage.getItem(LOCAL_STORAGE_KEYS.PROFILE_LANGUAGE);
};

export const Labels: Record<Language, Record<string, string>> = {
  nl,
  da,
  de,
  en,
  us,
  es,
  fi,
  fr,
  it,
  pl,
  pt,
};
